import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getItemsFromObject } from "../../../services/array/transformObject";
import { supportedCurrencies } from "../../../app/constants/currencies";
import { RootState } from "../../../app/store";
import storage from "redux-persist/es/storage";
import { persistReducer } from 'redux-persist';

const initialState = {
    selectedCurrency: getItemsFromObject(supportedCurrencies)[0],
  };
  
  const topNavbarSlice = createSlice({
    name: 'topNavbarSlice',
    initialState,
    reducers: {
      setSelectedCurrency(state, { payload }: PayloadAction<string>) {
        if (getItemsFromObject(supportedCurrencies).some((item) => item === payload)) {
            state.selectedCurrency = payload;
        }
      }
    },
  });
  
  export const { setSelectedCurrency } = topNavbarSlice.actions;

  const topNavbarPersistConfig = {
    key: "topNavbar",
    storage
};

export const topNavbarPersistReducer = persistReducer(topNavbarPersistConfig, topNavbarSlice.reducer);
  
  export const selectSelectedCurrency = (state: RootState) =>
    state.topNavbarSlice.selectedCurrency;
  
  export default topNavbarSlice.reducer;